import { agreementSharedRequestBodySchema, agreementSharedSuccessResponseBodySchema, agreementSharedRedisKeyNotFoundResponseBodySchema, conflictResponseBodySchema as sharedConflictResponseBodySchema, internalServerErrorResponseBodySchema as sharedInternalServerErrorResponseBodySchema, } from './agreement-shared.schema';
// Request
export var agreementAddRequestBodySchema = agreementSharedRequestBodySchema;
// Response code 200
export var agreementAddSuccessResponseBodySchema = agreementSharedSuccessResponseBodySchema;
// Response code 400
export var agreementAddRedisKeyNotFoundResponseBodySchema = agreementSharedRedisKeyNotFoundResponseBodySchema;
// Response code 409 - Agreement for provider exists
export var agreementAddConflictResponseBodySchema = sharedConflictResponseBodySchema;
// Response code 500 - Unexpected exception
export var agreementAddInternalServerErrorResponseBodySchema = sharedInternalServerErrorResponseBodySchema;
